import { Text } from "@overmap-ai/blocks"
import { type GeoImage, INDEX_FALLBACK } from "@overmap-ai/common"
import { selectGeoImageById } from "@overmap-ai/core"
import { cx } from "class-variance-authority"
import { memo } from "react"

import { useAppSelector } from "../../store"
import type { BaseIndexLabelProps } from "./typings"

interface GeoImageIndexLabelProps extends BaseIndexLabelProps {
	geoImageId: GeoImage["uuid"]
}

export const GeoImageIndexLabel = memo((props: GeoImageIndexLabelProps) => {
	const { className, geoImageId, ...rest } = props

	const geoImage = useAppSelector(selectGeoImageById(geoImageId))

	if (!geoImage) {
		throw new Error(`Could not find geoImage ${geoImageId}.`)
	}

	return (
		<Text className={cx("shrink-0 text-nowrap", className)} {...rest}>
			IMG-{geoImage.index ? geoImage.index : INDEX_FALLBACK}
		</Text>
	)
})
GeoImageIndexLabel.displayName = "GeoImageIndexLabel"
